module.exports = __webpack_public_path__ + "static/media/ArrowLeft.2ebded6a.svg";